<template>
    <tr :class="`${isEditRequested || isAddRequested ? 'edit-row' : ''}`">
        <td :colspan="`${isEditRequested || isAddRequested ? '2' : '1'}`" class="align-top">
            <div class="form-group form-check custom-checkbox">
                <input type="checkbox" id="payable" class="form-check-input" :checked="detail.isBillable" disabled />
                <label class="form-check-label" for="payable"></label>
            </div>
        </td>
        <template v-if="!isEditRequested && !isAddRequested">
            <td>
                <EmptyTextHandler :text="detail.payerName" />
            </td>
            <td>
                <EmptyTextHandler :text="formatDate(detail.visitStartTime)" />
            </td>
            <td>
                <EmptyTextHandler :text="formatTime(detail.visitStartTime)" />
            </td>
            <td>
                <EmptyTextHandler :text="formatDate(detail.visitEndTime)" />
            </td>
            <td>
                <EmptyTextHandler :text="formatTime(detail.visitEndTime)" />
            </td>
            <td>
                <EmptyTextHandler :text="detail.isBilled ? 'Yes' : 'No'" />
            </td>
            <td class="text-end">
                <i> No Actions </i>
            </td>
        </template>
        <td class="button-cell text-end" v-if="isEditRequested">
            <button type="button" class="btn table-btn btn-outline-success" @click="saveEditDetail()">Add</button>
            <button type="button" class="btn table-btn btn-outline-secondary" @click="cancelEditDetail()">
                Cancel
            </button>
        </td>
        <td class="button-cell text-end" v-if="isAddRequested">
            <button type="button" class="btn table-btn btn-outline-success" @click="save()">Add</button>
            <button type="button" class="btn table-btn btn-outline-secondary" @click="cancelSaveNewDetail()">
                Cancel
            </button>
        </td>
    </tr>
</template>

<script lang="ts" src="./MidnightSplitRow.ts"></script>
